"use client";

import React from "react";
import { Phone, MapPin, Clock } from "lucide-react";
export default function Header() {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };
  return <header className="w-full bg-white border-b border-[#E3E7EF] shadow-[0_6px_20px_rgba(7,27,58,0.06)] sticky top-0 z-50">
      {/* TOP BAR */}
      <div className="bg-[#071B3A] text-white">
        <div className="max-w-[1180px] mx-auto px-4 md:px-6 h-8 flex items-center justify-center md:justify-between text-[11px] md:text-[12px]">
          <div className="flex items-center gap-3 md:gap-5">
            <span className="flex items-center gap-2 whitespace-nowrap">
              <MapPin className="w-3.5 h-3.5 text-[#FF5A00]" />
              8635 W Pico Blvd, Los Angeles, CA 90035
            </span>

            <span className="hidden md:flex items-center gap-2">
              <Clock className="w-3.5 h-3.5 text-[#FF5A00]" />
              Open 7 days a week
            </span>
          </div>

          <span className="hidden lg:block font-black uppercase tracking-wide">
            <span className="text-[#FF5A00]">Fast same-day service</span>
            <span className="text-white/70"> • No appointment needed</span>
          </span>
        </div>
      </div>

      {/* MAIN HEADER */}
      <div className="max-w-[1180px] mx-auto px-3 md:px-6 h-[72px] md:h-[78px] flex items-center justify-between">
        {/* LOGO */}
        <button onClick={() => window.scrollTo({
        top: 0,
        behavior: "smooth"
      })} className="flex items-center justify-center text-left h-full shrink-0">
          <img src="https://novatirecenter.com/wp-content/uploads/2026/05/NOVA-NEW-LOGO-2.png" alt="Nova Tire Service" className="
              w-[300px]
              md:w-[400px]
              h-auto
              object-contain
              relative
              top-[10px]
              md:top-[16px]
              -left-[30px]
              md:-left-[55px]
            " />
        </button>

        {/* DESKTOP NAV */}
        <nav className="hidden lg:flex items-center gap-7 text-[15px] font-black uppercase text-[#111827]">
          <button onClick={() => scrollToSection("services")} className="hover:text-[#0B4DBA] transition">
            Services
          </button>

          <button onClick={() => scrollToSection("free-inspections")} className="hover:text-[#0B4DBA] transition">
            Free Inspections
          </button>

          <button onClick={() => scrollToSection("location")} className="hover:text-[#0B4DBA] transition">
            Location
          </button>

          <button onClick={() => scrollToSection("reviews")} className="hover:text-[#0B4DBA] transition">
            Reviews
          </button>

          <button onClick={() => scrollToSection("location")} className="hover:text-[#0B4DBA] transition">
            Contact
          </button>
        </nav>

        {/* DESKTOP PHONE */}
        <a href="tel:+14243138474" className="
            hidden
            sm:flex
            items-center
            gap-2
            text-[#0B4DBA]
            font-black
            md:text-[20px]
            shrink-0
            whitespace-nowrap
          ">
          <Phone className="w-5 h-5 text-[#FF5A00]" />
          <span>(424) 313-8474</span>
        </a>

        {/* MOBILE PREMIUM STATUS */}
        <div className="
            sm:hidden
            relative
            -left-[48px]
            top-[1px]
            flex
            items-center
            shrink-0
            whitespace-nowrap
          ">
          <span className="
              text-[#111827]
              font-black
              uppercase
              tracking-[0.12em]
              text-[11px]
              leading-none
            ">
            OPEN 7 DAYS
          </span>
        </div>
      </div>
    </header>;
}